/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Button } from "reactstrap";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox } from "@material-ui/core";




// Styles for the media section
const useStyles = makeStyles({
    // ... (keep all existing styles)
    mediaSection: {
        marginBottom: "30px",
    },
    mediaHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "15px"
    },
    mediaTabs: {
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        borderBottom: "2px solid #e0e0e0",
        paddingBottom: "10px"
    },
    mediaTab: {
        padding: "10px 20px",
        cursor: "pointer",
        borderRadius: "6px 6px 0 0",
        border: "1px solid #e0e0e0",
        borderBottom: "none",
        backgroundColor: "#f8f9fa",
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: "#e9ecef"
        }
    },
    mediaTabActive: {
        padding: "10px 20px",
        cursor: "pointer",
        borderRadius: "6px 6px 0 0",
        border: "1px solid #3498db",
        borderBottom: "none",
        backgroundColor: "#3498db",
        color: "white",
        fontWeight: "600"
    },
    storageInfo: {
        backgroundColor: "#e8f4fd",
        padding: "15px",
        borderRadius: "6px",
        marginBottom: "20px",
        border: "1px solid #b8daff"
    },
    storageProgress: {
        height: "8px",
        backgroundColor: "#dee2e6",
        borderRadius: "4px",
        margin: "10px 0",
        overflow: "hidden"
    },
    storageProgressBar: {
        height: "100%",
        backgroundColor: "#28a745",
        borderRadius: "4px"
    },
    imageGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: "15px",
        marginTop: "20px"
    },
    imageCard: {
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
        }
    },
    imageContainer: {
        height: "150px",
        overflow: "hidden",
        position: "relative",
        cursor: "pointer"
    },
    image: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        transition: "transform 0.3s ease",
        "&:hover": {
            transform: "scale(1.05)"
        }
    },
    imageInfo: {
        padding: "12px",
        backgroundColor: "white"
    },
    imageSize: {
        fontSize: "12px",
        color: "#6c757d",
        margin: "5px 0 0 0"
    },
    youtubeSection: {
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        marginBottom: "20px",
        border: "1px solid #e0e0e0"
    },
    youtubeGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "20px",
        marginTop: "20px"
    },
    youtubeCard: {
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        overflow: "hidden",
        transition: "all 0.2s ease",
        "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
        }
    },
    youtubeVideoContainer: {
        position: "relative",
        paddingBottom: "56.25%", // 16:9 aspect ratio
        height: "0",
        overflow: "hidden"
    },
    youtubeIframe: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        border: "none"
    },
    youtubeInfo: {
        padding: "15px",
        backgroundColor: "white"
    },
    youtubeTitle: {
        fontSize: "16px",
        fontWeight: "600",
        margin: "0 0 8px 0",
        color: "#2c3e50"
    },
    sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#2c3e50",
        margin: "0 0 15px 0"
    },
    emptyState: {
        textAlign: "center",
        padding: "40px",
        color: "#6c757d",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "2px dashed #dee2e6"
    },
    emptyStateIcon: {
        fontSize: "48px",
        marginBottom: "15px",
        opacity: "0.5"
    },
    // Add new styles for loading animation
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px",
        width: "100%"
    },
    loadingSpinner: {
        width: "50px",
        height: "50px",
        border: "5px solid #f3f3f3",
        borderTop: "5px solid #3498db",
        borderRadius: "50%",
        animation: "$spin 1s linear infinite"
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    }
});

function MediaSection({ listing }) {
    const styles = useStyles();
    const [activeTab, setActiveTab] = useState('images');
    const [images, setImages] = useState([]);
    const [storageUsed, setStorageUsed] = useState(0);
    const [storageTotal, setStorageTotal] = useState(60); // MB
    const [storagePercentage, setStoragePercentage] = useState(0);
    const [isLoading, setIsLoading] = useState(false); // Add loading state
    const [selectedImages, setSelectedImages] = useState(new Set()); // Track selected images

    const fetchImages = async () => {
        try {
            setIsLoading(true); // Start loading
            let images = Object.values(listing?.images ? listing.images : {}) || [];
            let names = Object.keys(listing?.images ? listing.images : {}) || [];

            const fetchedImages = [];

            // Use Promise.all to fetch all images concurrently
            const imagePromises = images.map(async (imageUrl, index) => {
                try {
                    const response = await fetch(imageUrl);
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }

                    const blob = await response.blob();
                    const imgURL = URL.createObjectURL(blob);

                    return {
                        name: names[index] || `image-${index}`,
                        size: Math.round(blob.size),
                        url: imgURL
                    };
                } catch (error) {
                    console.error("Error fetching image:", error);
                    // Return a placeholder for failed images
                    return {
                        name: names[index] || `image-${index}`,
                        size: 0,
                        url: 'https://via.placeholder.com/300x200?text=Image+Error',
                        error: true
                    };
                }
            });

            // Wait for all promises to resolve
            const results = await Promise.all(imagePromises);
            return results.filter(image => image !== null);

        } catch (error) {
            console.error("Error in fetchImages:", error);
            return [];
        } finally {
            setIsLoading(false); // Stop loading regardless of success or error
        }
    }

    useEffect(() => {
        const loadImages = async () => {
            const fetchedImages = await fetchImages(listing.images ? listing.images : {});
            setImages(fetchedImages);
        };

        loadImages();
    }, [listing.images]); // Add listing.images as dependency

    useEffect(() => {
        if (images.length > 0) {
            const storageUsed = +(images.reduce((acc, img) => acc + (img.size || 0), 0) / (1024 * 1024)).toFixed(1); // MB
            const storageTotal = 60; // MB
            const storagePercentage = (storageUsed / storageTotal) * 100;

            setStorageUsed(storageUsed);
            setStorageTotal(storageTotal);
            setStoragePercentage(storagePercentage);
        }
    }, [images])

    // Mock data for YouTube videos - replace with actual listing data
    const youtubeVideo = listing?.youtubeLinkId

    const getImageCaption = (image) => {
            const captions = listing?.captions || {};
        return captions[image.name] || "";
    }

    const handleImageClick = (imageUrl) => {
        // Open image in lightbox or new tab
        window.open(imageUrl, '_blank');
    };

    // Handler for toggling selection of an image
    const toggleSelectImage = (imageName) => {
        const newSelected = new Set(selectedImages);
        if (newSelected.has(imageName)) {
            newSelected.delete(imageName);
        } else {
            newSelected.add(imageName);
        }
        setSelectedImages(newSelected);
    };

    // Handler for Select All checkbox
    const toggleSelectAll = () => {
        if (selectedImages.size === images.length) {
            setSelectedImages(new Set());
        } else {
            setSelectedImages(new Set(images.map(img => img.name)));
        }
    };

    // Handler for Unselect All button
    const unselectAll = () => {
        setSelectedImages(new Set());
    };

    // Handler for Delete Selected button
    const deleteSelected = () => {
        if (selectedImages.size === 0) return;
        // Remove selected images from images state
        const remainingImages = images.filter(img => !selectedImages.has(img.name));
        setImages(remainingImages);
        setSelectedImages(new Set());
        // TODO: Add API call or update listing images in backend if needed
    };

    // Handler for Download Selected button
    const downloadSelected = () => {
        if (selectedImages.size === 0) return;
        // Download each selected image by creating a temporary link and clicking it
        selectedImages.forEach(name => {
            const img = images.find(i => i.name === name);
            if (img) {
                const link = document.createElement('a');
                link.href = img.url;
                link.download = img.name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    };

    return (
        <div className={styles.mediaSection}>
            <div className={styles.mediaHeader}>
                <h2 className={styles.sectionTitle}>Multimedia</h2>
            </div>

            {/* Media Tabs */}
            <div className={styles.mediaTabs}>
                <div
                    className={activeTab === 'images' ? styles.mediaTabActive : styles.mediaTab}
                    onClick={() => setActiveTab('images')}
                >
                    Images
                </div>
                <div
                    className={activeTab === 'youtube' ? styles.mediaTabActive : styles.mediaTab}
                    onClick={() => setActiveTab('youtube')}
                >
                    YouTube
                </div>
                <div
                    className={activeTab === 'videos' ? styles.mediaTabActive : styles.mediaTab}
                    onClick={() => setActiveTab('videos')}
                >
                    Videos
                </div>
            </div>

            {/* Images Tab Content */}
            {activeTab === 'images' && (
                <Card className={styles.Card}>
                    <CardBody>
                        {/* Storage Information */}
                        <div className={styles.storageInfo}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Property24 Limit: {storageUsed} MB / {storageTotal} MB</span>
                                <span>{storagePercentage.toFixed(1)}%</span>
                            </div>
                            <div className={styles.storageProgress}>
                                <div
                                    className={styles.storageProgressBar}
                                    style={{ width: `${storagePercentage}%` }}
                                ></div>
                            </div>
                            <small>Maximum 60MB total storage for images</small>
                        </div>

                        {/* Loading Animation */}
                        {isLoading && (
                            <div className={styles.loadingContainer}>
                                <div className={styles.loadingSpinner}></div>
                            </div>
                        )}

                        {/* Select All Checkbox and Bulk Action Buttons */}
                        {!isLoading && images.length > 0 && (
                            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Checkbox
                                    checked={selectedImages.size === images.length}
                                    indeterminate={selectedImages.size > 0 && selectedImages.size < images.length}
                                    onChange={toggleSelectAll}
                                    inputProps={{ 'aria-label': 'Select all images' }}
                                />
                                <span>Select All</span>

                                {selectedImages.size > 0 && (
                                    <>
                                        <Button color="secondary" size="sm" onClick={unselectAll}>
                                            Unselect All
                                        </Button>
                                        <Button color="danger" size="sm" onClick={deleteSelected}>
                                            Delete Selected
                                        </Button>
                                        <Button color="primary" size="sm" onClick={downloadSelected}>
                                            Download Selected
                                        </Button>
                                    </>
                                )}
                            </div>
                        )}

                        {/* Image Grid */}
                        {!isLoading && images.length > 0 ? (
                            <div className={styles.imageGrid}>
                                {images.map((image) => (
                                    <div key={image.name} className={styles.imageCard}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Checkbox
                                                checked={selectedImages.has(image.name)}
                                                onChange={() => toggleSelectImage(image.name)}
                                                inputProps={{ 'aria-label': `Select image ${image.name}` }}
                                            />
                                            <div
                                                className={styles.imageContainer}
                                                onClick={() => handleImageClick(image.url)}
                                                style={{ flex: 1 }}
                                            >
                                                <img
                                                    src={image.url}
                                                    alt={image.name}
                                                    className={styles.image}
                                                    onError={(e) => {
                                                        e.target.src = 'https://via.placeholder.com/300x200?text=Image+Not+Found';
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className={styles.imageInfo}>
                                            <div style={{ fontWeight: '500', fontSize: '14px' }}>
                                                {getImageCaption(image)}
                                            </div>
                                            <div className={styles.imageSize}>
                                                {(image.size / (1024 * 1024)).toFixed(2)} MB
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : !isLoading && (
                            <div className={styles.emptyState}>
                                <div className={styles.emptyStateIcon}>🖼️</div>
                                <h4>No Images Available</h4>
                                <p>This property doesn't have any images yet.</p>
                            </div>
                        )}
                    </CardBody>
                </Card>
            )}

            {/* YouTube Tab Content */}
            {activeTab === 'youtube' && (
                <Card className={styles.Card}>
                    <CardBody>
                        {youtubeVideo ? (
                            <>
                                <div className={styles.youtubeGrid}>
                                    <div className={styles.youtubeCard}>
                                        <div className={styles.youtubeVideoContainer}>
                                            <iframe
                                                src={`https://www.youtube.com/embed/${youtubeVideo}`}
                                                className={styles.youtubeIframe}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                                title="YouTube video"
                                            ></iframe>
                                        </div>
                                        <div className={styles.youtubeInfo}>
                                            <a
                                                href={`https://www.youtube.com/watch?v=${youtubeVideo}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ fontSize: '14px', color: '#3498db' }}
                                            >
                                                View on YouTube
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className={styles.emptyState}>
                                <div className={styles.emptyStateIcon}>📺</div>
                                <h4>No YouTube Videos</h4>
                                <p>This property doesn't have any YouTube videos yet.</p>
                            </div>
                        )}
                    </CardBody>
                </Card>
            )}

            {/* Videos Tab Content */}
            {activeTab === 'videos' && (
                <Card className={styles.Card}>
                    <CardBody>
                        <div className={styles.emptyState}>
                            <div className={styles.emptyStateIcon}>🎬</div>
                            <h4>No Video Files</h4>
                            <p>This property doesn't have any uploaded video files yet.</p>
                        </div>
                    </CardBody>
                </Card>
            )}
        </div>
    );
}

export default MediaSection;